// extracted by mini-css-extract-plugin
export default {"spinContainer":"LoadingPage_spinContainer__Lskyl"};